<template>
  <v-container class="w-div-loader pa-0">
    <v-flex xs12>
      <slot name="before" />
    </v-flex>
    <v-layout align-center fill-height justify-center>
      <v-flex class="w-div-loader__container" xs12 align-self-center>
        <undraw-loader :height="height" />
        <h3 class="title">Un petit instant</h3>
        <div class="w-div-loader__content">
          <v-progress-circular indeterminate color="primary" />
          <slot />
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import UndrawLoader from 'vue-undraw/UndrawCoffeeBreak.vue'

export default {
  components: {
    UndrawLoader,
  },
  props: {
    height: {
      type: String,
      default: '200px',
    },
  },
}
</script>

<style lang="scss">
.w-div-loader {
  &__container {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  &__content {
    margin-top: 24px;
  }
  p {
    margin-top: 8px;
    font-size: 16px !important;
  }
}
</style>
